

/* eslint-disable-next-line */
(function ($) {
	$(document).ready(function () {

		$(".js-post-related-video-btn")
			.on("click", function (evt) {

				let modal_id = $(this).data("bs-target");

				let video_url = $(this).data("video-url");

				// If video is from YouTube
				if (video_url.includes("youtube.com") || video_url.includes("youtu.be")) {

					let video_id = "";

					// If URL matches https://www.youtube.com/watch?v={video_id} format
					if (video_url.includes("watch?")) {

						// Pull out video ID from URL
						let matches = video_url.match(/watch\?v\=([0-9a-zA-Z_\-]+)/);

						video_id = matches[1];

					} else {

						// Remove "http?s://" from beginning
						let processed_video_url = video_url.replace(/http?s:\/\//, "");

						// Remove query string from URL, if it exists
						if (processed_video_url.includes("?")) {
							processed_video_url = processed_video_url.substr(0, processed_video_url.indexOf("?"));
						}

						let video_url_parts = processed_video_url.split("/");
						console.log(video_url_parts);

						video_id = video_url_parts[1];

					}

					// Hide video element.
					$(modal_id).find("video.embedded-video").hide();

					// Set iframe src URL and show iframe element.
					$(modal_id).find("iframe.youtube-video").get(0).src = "https://www.youtube.com/embed/" + video_id + "?enablejsapi=1&version=3&playerapiid=ytplayer";
					$(modal_id).find("iframe.youtube-video").show();

				} else {

					// Hide video element.
					$(modal_id).find("iframe.youtube-video").hide();

					// Set iframe src URL and show iframe element.
					$(modal_id).find("video.embedded-video > source").get(0).src = video_url;
					$(modal_id).find("video.embedded-video").show();

				}

				return false;

			});

	});

	/* eslint-disable-next-line */
})(jQuery);